import React from 'react'
import { Tooltip } from 'antd'
import {
  InvoicePaymentType,
  InvoiceTemplate,
} from '../../../api/dto/invoice-delivery.dto'
import {
  INVOICE_TEMPLATE_CUSTOMER_LABELS,
  INVOICE_TEMPLATE_LABELS,
  PAYMENT_TYPE_LABELS,
} from './invoiceTemplates'
import { TemplateTagDivider, TemplateTagPill } from './emailTemplates.styles'

/** Only the OE pair names its payment method: it is what tells OE1 and OE2 apart at a glance. */
const SHOWS_PAYMENT: ReadonlySet<InvoiceTemplate> = new Set([
  InvoiceTemplate.OE_FIRST,
  InvoiceTemplate.OE_FINAL,
])

interface EmailTemplateTagProps {
  template: InvoiceTemplate
  paymentType?: InvoicePaymentType | null
  /** Invoice List shows the name a customer would recognize. */
  isCustomerFacing?: boolean
}

const EmailTemplateTag: React.FC<EmailTemplateTagProps> = ({
  template,
  paymentType,
  isCustomerFacing = false,
}) => {
  const paymentLabel =
    SHOWS_PAYMENT.has(template) && paymentType
      ? PAYMENT_TYPE_LABELS[paymentType]
      : null
  const label = isCustomerFacing
    ? INVOICE_TEMPLATE_CUSTOMER_LABELS[template]
    : INVOICE_TEMPLATE_LABELS[template]
  const pill = (
    <TemplateTagPill $template={template}>
      {label}
      {paymentLabel ? (
        <>
          <TemplateTagDivider aria-hidden="true">·</TemplateTagDivider>
          {paymentLabel}
        </>
      ) : null}
    </TemplateTagPill>
  )
  const customerLabel = INVOICE_TEMPLATE_CUSTOMER_LABELS[template]
  if (isCustomerFacing || customerLabel === label) return pill
  return <Tooltip title={customerLabel}>{pill}</Tooltip>
}

export { EmailTemplateTag }
